import { render, staticRenderFns } from "./AydemTestView.vue?vue&type=template&id=8bc04762&scoped=true&"
import script from "./AydemTestView.vue?vue&type=script&lang=js&"
export * from "./AydemTestView.vue?vue&type=script&lang=js&"
import style0 from "./AydemTestView.vue?vue&type=style&index=0&id=8bc04762&scoped=true&lang=scss&"
import style1 from "./AydemTestView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc04762",
  null
  
)

export default component.exports